import { render } from "./ActiveAdsSummaryReport.vue?vue&type=template&id=3af3458b&ts=true"
import script from "./ActiveAdsSummaryReport.vue?vue&type=script&lang=ts"
export * from "./ActiveAdsSummaryReport.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__